import {useContext} from 'react';

import type {AppContextValue} from './AppContext';

import AppContext from './AppContext';

export default function useAppContext(): AppContextValue {
  return useContext(AppContext);
}
